import SignupAds from "./signup-ads/SignupAds";
import RegistrationForm from "./registration-form/RegistrationForm";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import LoginForm from "../../liber-login/LoginForm";
import LoginAds from "../../liber-login/LoginAds";

export function LoginAndRegistrationMainContainer() {
  const location = useLocation();
  const isSignup = location?.pathname === "/sign-up";

  return (
    <PageWrap $isLogin={!isSignup}>
      <Inner $isLogin={!isSignup}>
        <LeftColumn>
          {isSignup ? <SignupAds /> : <LoginAds />}
        </LeftColumn>
        <RightColumn>
          {isSignup ? <RegistrationForm /> : <LoginForm />}
        </RightColumn>
      </Inner>
    </PageWrap>
  );
}

const PageWrap = styled.div`
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px 56px;
  box-sizing: border-box;
  text-align: left;
  min-height: ${(p) => (p.$isLogin ? "auto" : "100vh")};
  width: 100%;
  flex: ${(p) => (p.$isLogin ? "1" : "none")};

  @media (min-width: 960px) {
    padding: 48px 32px 64px;
  }
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1120px;
  display: grid;
  gap: 40px;
  align-items: center;

  @media (min-width: 960px) {
    grid-template-columns: minmax(0, 1.05fr) minmax(360px, 460px);
    gap: 48px 56px;
  }
`;

const LeftColumn = styled.div`
  display: none;

  @media (min-width: 960px) {
    display: block;
    min-width: 0;
  }
`;

const RightColumn = styled.div`
  width: 100%;
  min-width: 0;
`;
